(() => {
  const CLICK_DELAY = 280;
  let clickTimer = null;
  let lastCard = null;
  let lastClickAt = 0;

  function createLightbox() {
    let box = document.getElementById('talia-image-lightbox');
    if (box) return box;

    box = document.createElement('div');
    box.id = 'talia-image-lightbox';
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML = `
      <button class="talia-lightbox-close" type="button" aria-label="Zavrieť obrázok">×</button>
      <img class="talia-lightbox-image" alt="">
    `;
    document.body.appendChild(box);

    const close = () => {
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      const img = box.querySelector('.talia-lightbox-image');
      if (img) img.removeAttribute('src');
    };

    box.addEventListener('click', (e) => {
      if (e.target === box || e.target.closest('.talia-lightbox-close')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });

    box._taliaClose = close;
    return box;
  }

  function bestImageUrl(img, fallback) {
    const srcset = img.getAttribute('srcset');
    if (srcset) {
      const candidates = srcset.split(',')
        .map(item => {
          const parts = item.trim().split(/\s+/);
          const width = parseInt((parts[1] || '').replace('w',''), 10) || 0;
          return { url: parts[0], width };
        })
        .sort((a,b) => a.width - b.width);
      if (candidates.length && candidates[candidates.length - 1].url) {
        return candidates[candidates.length - 1].url;
      }
    }
    return fallback || img.currentSrc || img.src;
  }

  function openLightbox(img, mediaLink) {
    const box = createLightbox();
    const full = bestImageUrl(img, mediaLink?.dataset?.fullImage);
    const target = box.querySelector('.talia-lightbox-image');
    if (!target || !full) return;
    target.src = full;
    target.alt = img.alt || '';
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
  }

  function openQuickView(card, mediaLink) {
    const quick = card.querySelector('card-quick-view-button');
    if (quick) {
      quick.click();
      return;
    }
    if (mediaLink?.href) window.location.href = mediaLink.href;
  }

  document.addEventListener('click', (event) => {
    const img = event.target.closest('.product-card-media .product-media img');
    if (!img) return;

    const mediaLink = img.closest('.product-media');
    const card = img.closest('[data-product-card-wrapper]');
    if (!mediaLink || !card) return;

    event.preventDefault();
    event.stopPropagation();

    const now = Date.now();
    const isDouble = lastCard === card && (now - lastClickAt) <= CLICK_DELAY;

    if (isDouble) {
      if (clickTimer) clearTimeout(clickTimer);
      clickTimer = null;
      lastCard = null;
      lastClickAt = 0;
      openLightbox(img, mediaLink);
      return;
    }

    lastCard = card;
    lastClickAt = now;
    if (clickTimer) clearTimeout(clickTimer);
    clickTimer = setTimeout(() => {
      openQuickView(card, mediaLink);
      clickTimer = null;
      lastCard = null;
      lastClickAt = 0;
    }, CLICK_DELAY);
  }, true);

  document.addEventListener('dblclick', (event) => {
    if (event.target.closest('.product-card-media .product-media img')) {
      event.preventDefault();
    }
  }, true);
})();
